import React from "react";
import Router from "next/router";

import { web } from "@kikoff/proto/src/protos";
import { format } from "@kikoff/utils/src/string";

import confettiBanner from "@component/dashboard/images/confetti-banner.svg";
import ViewTemplate from "@component/dashboard/offer/view_template";
import { PageRegistration } from "@component/flows/hooks/usePageFlow";
import { track } from "@util/analytics";
import { nativeDispatch } from "@util/mobile";

import styles from "./creditline_increase_congrats.module.scss";

interface CreditIncreaseCongratsViewProps extends PageRegistration {
  preview: web.public_.ICheckoutPreviewResponse;
  message?: string;
  isFinalPage?: boolean;
}

const CreditIncreaseCongratsView: React.FC<CreditIncreaseCongratsViewProps> = ({
  preview,
  configFlow,
  Button,
  message,
  isFinalPage,
}) => {
  const newCreditLineValue = preview.newCreditLimitCents;

  configFlow.button(
    <Button
      onClick={(e) => {
        track.tap(
          "CA - Plan Details - Credit Increase Congrats - Continue Button"
        );
        nativeDispatch("requestReview");
        if (isFinalPage) {
          e.preventDefault();
          Router.replace("/dashboard/credit-account/plan");
        }
      }}
    >
      {isFinalPage ? "Go to dashboard" : "Continue"}
    </Button>,
    [isFinalPage]
  );

  return (
    <ViewTemplate className={styles["congrats-wrapper"]}>
      <img
        className={styles["confetti-banner"]}
        src={confettiBanner.src}
        alt="confetti"
      />
      <div className={styles["congrats-content"]}>
        <div className={styles["congrats-title"]}>Congratulations!</div>

        <div className={styles["increased-prompt"]}>
          {message || "Your credit limit has been increased to"}
        </div>
        <div className={styles["new-creditline-value"]}>
          {format.money(newCreditLineValue)}!
        </div>
        <div className={styles["great-work"]}>
          Continue doing great work building credit!
        </div>
      </div>
    </ViewTemplate>
  );
};

export default CreditIncreaseCongratsView;
